import React, { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../contexts/AuthContext'
import { Role } from '../../types/index'

/**
 * Protected route props
 */
interface ProtectedRouteProps {
  children: ReactNode
  requiredRole?: Role | Role[]
  fallback?: ReactNode
}

/**
 * Protected route component
 * @param props - Component props
 * @returns Protected route or redirect
 */
function ProtectedRoute({ children, requiredRole, fallback }: ProtectedRouteProps): React.JSX.Element {
  const { t } = useTranslation()
  const { isAuthenticated, user, loading } = useAuth()

  if (loading) {
    return <div>{t('common.loading')}</div>
  }

  if (!isAuthenticated) {
    if (fallback) return <>{fallback}</>
    return <Navigate to="/login" replace />
  }

  if (requiredRole) {
    const roles = Array.isArray(requiredRole) ? requiredRole : [requiredRole]
    if (!user || !roles.includes(user.role)) {
      return <Navigate to="/" replace />
    }
  }

  return <>{children}</>
}

export default ProtectedRoute
